import { useSelector } from 'react-redux';
import { Flex } from 'foundations-components/components/Flex';

// @ts-expect-error untyped
import { isLoading, isError } from 'reference-resolvers/utils';
import { DEAL_STAGE } from '../../constants/DealGroupingType';
import { PipelineFilter } from './PipelineFilter';
import TimePeriodFilterCustom from './TimePeriodFilterCustom';
import UserAndTeamSearchContainer from './UserAndTeamSearchContainer';
import DealGroupingTypeFilter from './DealGroupingTypeFilter';
import { getHasViewAllScope, getHasViewTeamScope, getIsUngatedToForecastingMultipleOutcomes, getUserPrimaryTeam } from '../../selectors/authSelectors';
import { getDealGroupingTypeFilter } from '../../selectors/filtersSelectors';
import { getFetchOwnersSucceeded } from '../../selectors/ownersSelectors';
import { ForecastTypeFilter } from './ForecastTypeFilter';
import { MULTI, ONE } from '../../constants/FiltersConstants';
import { getTeamsMap } from '../../selectors/usersSelectors';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ForecastFilters = ({
  handleSelectUserOrTeam,
  isDetail
}) => {
  const canViewTeam = useSelector(getHasViewTeamScope);
  const canViewAll = useSelector(getHasViewAllScope);
  const userPrimaryTeam = useSelector(getUserPrimaryTeam);
  const dealGroupingType = useSelector(getDealGroupingTypeFilter);
  const isUngatedToForescastMultipleOutcomes = useSelector(getIsUngatedToForecastingMultipleOutcomes);
  const isOwnersFetchSucceeded = useSelector(getFetchOwnersSucceeded);
  const teams = useSelector(getTeamsMap);
  const isDealStageGrouping = dealGroupingType === DEAL_STAGE;
  const skipRender = [teams].some(reference => isLoading(reference) || isError(reference));
  if (skipRender) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isUngatedToForescastMultipleOutcomes && /*#__PURE__*/_jsx(ForecastTypeFilter, {
      isDetail: isDetail
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexWrap: "wrap",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexWrap: "wrap",
        justifyContent: "start",
        children: [/*#__PURE__*/_jsx(DealGroupingTypeFilter, {}), /*#__PURE__*/_jsx(PipelineFilter, {
          isDealStageGrouping: isDealStageGrouping,
          selectType: isDealStageGrouping ? ONE : MULTI
        }), /*#__PURE__*/_jsx(TimePeriodFilterCustom, {})]
      }), !isDetail && !isOwnersFetchSucceeded && /*#__PURE__*/_jsx(LoadingSpinner, {}), !isDetail && isOwnersFetchSucceeded && /*#__PURE__*/_jsx(UserAndTeamSearchContainer, {
        canViewAll: canViewAll,
        canViewTeam: canViewTeam,
        handleSelectUserOrTeam: handleSelectUserOrTeam,
        teams: teams,
        userPrimaryTeam: userPrimaryTeam
      })]
    })]
  });
};
export default ForecastFilters;